import { NgModule } from '@angular/core';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { SiModalModule } from '../si-modal';
import { CommonModule } from '@angular/common';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    declarations: [ConfirmationDialogComponent],
    exports: [ConfirmationDialogComponent],
    imports: [
        DisableAutocompleteDirectiveModule,
        SiModalModule,
        CommonModule,
        FontAwesomeModule,
    ]
})
export class ConfirmationDialogModule {}
